import type { ConditionRatingNotRated } from "./referential-condition-ratings.type";

export const CONDITION_RATING_NOT_RATED: ConditionRatingNotRated = "not-rated";
